/* eslint-disable react/destructuring-assignment */
import { TextField, makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
}));
const CommonTextField = (props, {
  color, variant, size, children, className,
}) => {
  const classes = useStyles();
  const color1 = color !== undefined ? color : 'primary';
  const variant1 = variant !== undefined ? variant : 'outlined';
  const size1 = size !== undefined ? size : 'medium';
  return (
    <TextField
      {...props}
      variant={variant1}
      color={color1}
      size={size1}
      className={clsx(classes.root, className)}
      onChange={(e) => props.handleChange(e.target.value, props.name)}
    >
      {children}
    </TextField>
  );
};
export default CommonTextField;
